export default __webpack_public_path__ + "static/media/raising-futures-kenya-charity.3597e497.jpg";